import { getMessaging } from 'firebase/messaging'
import { app } from './app'

export const VAPID_KEY =
  'BOZqeVPNLqBiJC26WHRIwJcy38SOvbK2LgHAZUheFaPVAy-ghHYf8wvxUCw0pyMmJl83RM2kjug5ozxSMIXva0A'
export const messaging = getMessaging(app)
